"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAccount = checkAccount;
exports.getFile = getFile;
exports.getGroupPermission = getGroupPermission;
exports.getUserInfo = getUserInfo;
exports.login = login;
exports.logout = logout;
exports.uploadFile = uploadFile;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _utils = require("@/utils");

var _request = _interopRequireDefault(require("@/utils/request"));

var _getFile = _interopRequireDefault(require("@/utils/getFile"));

// 登录
function login(data) {
  return (0, _request.default)({
    url: '/auth/login',
    method: 'post',
    data: data
  });
} // 退出


function logout() {
  return (0, _request.default)({
    url: '/auth/logout',
    method: 'post'
  });
} // 获取权限组的权限id


function getGroupPermission(params) {
  var groupId = params.group_id;
  var p = localStorage.getItem((0, _utils.getStorageKey)('group_permission_' + groupId));

  if (p) {
    return new Promise(function (resolve) {
      resolve({
        data: {
          ret: 0,
          data: p.split(',')
        }
      });
    });
  }

  return (0, _request.default)({
    url: '/admin/permission/getGroupPermission',
    method: 'get',
    params: params
  });
} // 校验账号密码


function checkAccount(params) {
  return (0, _request.default)({
    url: '/anonymity/checkAccount',
    method: 'get',
    params: params
  });
} // 获取用户信息


function getUserInfo() {
  return (0, _request.default)({
    url: '/developer/getUserInfo',
    method: 'get'
  });
}

function uploadFile(data) {
  return (0, _request.default)({
    url: '/admin/common/uploadFile',
    method: 'post',
    data: data
  });
} // 获取文件内容


function getFile(url) {
  return (0, _getFile.default)({
    url: url,
    method: 'get'
  });
}